import React, { createContext, useContext, useState, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { productListLocationsArray } from '../../../../Components/helper';

const uniqueKey = uuidv4();
const enterText = 'Enter Text';
const selectOptions = 'Select Option';
const numberDecimal = 'Number (Decimal)';
const numberPercentage = 'Number (Percentage)';
const fontFamily = 'Cedarville Cursive, cursive';
const companyStamp = 'Company Stamp';
const leftColumn = [
  {
    canvas: [
      {
        type: 'container',
        key: 'portrait_page',
        id: `${uniqueKey}_portrait`,
        label: 'ADD_PORTRAIT',
      },
      {
        type: 'container',
        key: 'content_page',
        id: `${uniqueKey}_content`,
        label: 'ADD_CONTENT_PAGE',
      },
    ],
  },
  {
    components: [
      {
        type: 'item',
        id: '23',
        key: 'Heading',
        label: 'Heading',
        placeholder: 'Enter Heading',
        headingStyle: { label: 'Normal Text', value: 'normal' },
        supplierVisible: true,
        supplierEditable: true,
        isStatic: false,
        w: 2,
        h: 1,
      },
      {
        type: 'item',
        id: '5',
        key: 'Text_Area',
        label: 'Text Area',
        placeholder: enterText,
        supplierVisible: true,
        supplierEditable: true,
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '6',
        key: 'Text',
        label: 'Textbox',
        placeholder: enterText,
        supplierVisible: true,
        supplierEditable: true,
        w: 2,
        h: 1,
      },
      {
        type: 'item',
        id: '7',
        key: 'Dropdown',
        label: 'Dropdown',
        placeholder: selectOptions,
        supplierVisible: true,
        supplierEditable: true,
        options: [{ name: 'Option 1', label: 'Option 1', uniqueKey: `${uniqueKey}_drop_1` }],
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '30',
        key: 'Dependent',
        label: 'Dependent',
        supplierVisible: true,
        supplierEditable: false,
        fixed: true,
        dropDownControl: null,
        isContentArr: [{ isContent: null, to: '' }],
        dropDownControlOptions: [],
        isControlOptions: [],
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '14',
        key: 'Multi_Dropdown',
        label: 'Multi Dropdown',
        placeholder: selectOptions,
        supplierVisible: true,
        supplierEditable: true,
        options: [{ label: 'Option One', value: 'opt1' }],
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '8',
        key: 'Check_Boxes',
        label: 'Checkbox',
        placeholder: '',
        supplierVisible: true,
        supplierEditable: true,
        options: [
          { name: 'Option 1', label: 'Option 1', uniqueKey: `${uniqueKey}_check_1` },
          { name: 'Option 2', label: 'Option 2', uniqueKey: `${uniqueKey}_check_2` },
        ],
        w: 2,
        h: 4,
      },
      {
        type: 'item',
        id: '9',
        key: 'Ratio_Button',
        label: 'Radio Button',
        placeholder: '',
        supplierVisible: true,
        supplierEditable: true,
        options: [
          { name: 'Option 1', label: 'Option 1', uniqueKey: `${uniqueKey}_radio_1` },
          { name: 'Option 2', label: 'Option 2', uniqueKey: `${uniqueKey}_radio_2` },
        ],
        w: 2,
        h: 4,
      },
      {
        type: 'item',
        id: '10',
        key: 'Date_Picker',
        label: 'Date Picker',
        placeholder: '',
        range: false,
        supplierVisible: true,
        supplierEditable: true,
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '11',
        key: 'Time_Picker',
        label: 'Time Picker',
        placeholder: '',
        supplierVisible: true,
        supplierEditable: true,
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '15',
        key: 'Status',
        label: 'Status',
        supplierVisible: true,
        supplierEditable: true,
        statusColours: [
          {
            colourName: 'Yellow',
            colourHexCode: '#fbb755',
          },
          {
            colourName: 'Orange',
            colourHexCode: '#dc6d5b',
          },

          {
            colourName: 'Red',
            colourHexCode: '#f65158',
          },
          {
            colourName: 'Pink',
            colourHexCode: '#dc5bc2',
          },
          {
            colourName: 'Teal',
            colourHexCode: '#2c7d6d',
          },
        ],
        w: 2,
        h: 3,
      },
      {
        type: 'item',
        id: '16',
        key: 'Number_Decimal',
        label: numberDecimal,
        placeholder: numberDecimal,
        supplierVisible: true,
        supplierEditable: true,
        isColourCoding: false,
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '17',
        key: 'Number_Percentage',
        label: numberPercentage,
        placeholder: numberPercentage,
        supplierVisible: true,
        supplierEditable: true,
        isColourCoding: false,
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '24',
        key: 'Image',
        label: 'Image',
        placeholder: 'Upload Image',
        imageUrl: '',
        supplierVisible: true,
        supplierEditable: true,
        w: 2,
        h: 4,
      },
      {
        type: 'item',
        id: '28',
        key: 'Table',
        label: 'Table',
        tableColumns: [],
        tableData: [],
        supplierVisible: true,
        supplierEditable: true,
        w: 4,
        h: 2,
      },
      {
        type: 'item',
        id: '18',
        key: 'Signature',
        label: 'Signature',
        placeholder: 'Signature',
        supplierVisible: true,
        supplierEditable: true,
        digitalSignPath: '',
        fontFamily,
        fontStyles: [
          {
            font: fontFamily,
          },
          {
            font: 'Alex Brush, cursive',
          },
          {
            font: 'Dancing Script, cursive',
          },
          {
            font: 'Indie Flower, cursive',
          },
          {
            font: 'Nothing You Could Do, cursive',
          },
          {
            font: 'Sacramento, cursive',
          },
        ],
        w: 2,
        h: 3,
      },
      {
        type: 'item',
        id: '19',
        key: 'Company_Stamp',
        label: companyStamp,
        placeholder: companyStamp,
        supplierVisible: true,
        supplierEditable: true,
        companyLogo: '',
        w: 2,
        h: 3,
      },
      {
        type: 'item',
        id: '20',
        key: 'Label',
        label: 'Label',
        placeholder: 'Label',
        supplierVisible: true,
        supplierEditable: true,
        labelColours: [
          {
            colourName: 'Red',
            colourHexCode: '#f65158',
          },
          {
            colourName: 'Yellow',
            colourHexCode: '#fbb755',
          },
          {
            colourName: 'Green',
            colourHexCode: '#159e79',
          },
          {
            colourName: 'Light Grey',
            colourHexCode: '#cecece',
          },
          {
            colourName: 'Mid Grey',
            colourHexCode: '#848484',
          },
        ],
        w: 2,
        h: 3,
      },
      {
        type: 'item',
        id: '26',
        key: 'HTMLControl',
        label: 'HTML Control',
        placeholder: 'HTML',
        ckeditorData: '',
        supplierVisible: true,
        supplierEditable: true,
        w: 4,
        h: 2,
      },
      {
        type: 'item',
        id: '25',
        key: 'Divider',
        label: 'Divider',
        dividerProperty: {
          width: 100,
          weight: 4,
          gap: 0,
        },
        dividerStyle: { label: 'Solid', value: 'solid' },
        supplierVisible: true,
        supplierEditable: true,
        w: 1,
        h: 1,
      },
      {
        type: 'item',
        id: '27',
        key: 'Source',
        label: 'Source',
        supplierVisible: true,
        supplierEditable: false,
        w: 2,
        h: 1,
      },
      {
        type: 'item',
        id: '28',
        key: 'Calculation',
        label: 'Calculation',
        supplierVisible: true,
        supplierEditable: false,
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        w: 2,
        h: 2,
      },
      {
        type: 'item',
        id: '29',
        key: 'Colorfill',
        label: 'Color Fill',
        supplierVisible: true,
        supplierEditable: false,
        w: 1,
        h: 1,
      },
    ],
  },
];

const useTableControls = () => {
  const { t } = useTranslation('common');
  const sourcePath = 'CUSTOM_LIBRARY.SOURCE_TYPE.SOURCE';
  const calculationPath = 'CUSTOM_LIBRARY.CALCULATION_TYPE.CALCULATION';
  return [
    {
      key: 'Text_Area',
      label: 'Text Area',
      placeholder: enterText,
      isActive: true,
    },
    {
      key: 'Text',
      label: 'Textbox',
      placeholder: enterText,
      isActive: true,
    },
    {
      key: 'Dropdown',
      label: 'Dropdown',
      placeholder: selectOptions,
      isActive: true,
    },
    {
      key: t('CUSTOM_LIBRARY.STATIC_CONTROLS.DEPENDENT'),
      label: t('CUSTOM_LIBRARY.STATIC_CONTROLS.DEPENDENT'),
      placeholder: t('CUSTOM_LIBRARY.STATIC_CONTROLS.DEPENDENT_PLACEHOLDER'),
      isActive: true,
      relation: {
        controlLoading: false,
        dropControlLoading: false,
        hasError: false,
        fixed: true,
        dropDownControl: null,

        DependentLoader: false,
        dropDownControlOptions: [],
        isControlOptions: [],
        name: '',
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
      },
    },
    {
      key: 'Multi_Dropdown',
      label: 'Multi Dropdown',
      placeholder: selectOptions,
      isActive: true,
    },
    {
      key: 'Check_Boxes',
      label: 'Checkbox',
      placeholder: '',
      isActive: true,
    },
    {
      key: 'Ratio_Button',
      label: 'Radio Button',
      placeholder: '',
      isActive: true,
    },
    {
      key: 'Date_Picker',
      label: 'Date Picker',
      placeholder: '',
      isActive: true,
    },
    {
      key: 'Time_Picker',
      label: 'Time Picker',
      placeholder: '',
      isActive: true,
    },

    {
      key: 'Paragraph',
      label: 'Paragraph',
      placeholder: '',
      isActive: true,
    },
    {
      key: 'Status',
      label: 'Status',
      // placeholder: "",
      statusColours: [
        {
          colourName: 'Yellow',
          colourHexCode: '#fbb755',
        },
        {
          colourName: 'Orange',
          colourHexCode: '#dc6d5b',
        },

        {
          colourName: 'Red',
          colourHexCode: '#f65158',
        },
        {
          colourName: 'Pink',
          colourHexCode: '#dc5bc2',
        },
        {
          colourName: 'Teal',
          colourHexCode: '#2c7d6d',
        },
      ],
      isActive: true,
    },
    {
      key: 'Number_Decimal',
      label: numberDecimal,
      placeholder: numberDecimal,
      isColourCoding: false,
      colourArray: [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ],
      isActive: true,
    },
    {
      key: 'Number_Percentage',
      label: numberPercentage,
      placeholder: numberPercentage,
      isColourCoding: false,
      colourArray: [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ],
      isActive: true,
    },
    {
      key: 'Signature',
      label: 'Signature',
      placeholder: 'Signature',
      digitalSignPath: '',
      fontFamily,
      fontStyles: [
        {
          font: fontFamily,
        },
        {
          font: 'Alex Brush, cursive',
        },
        {
          font: 'Dancing Script, cursive',
        },
        {
          font: 'Indie Flower, cursive',
        },
        {
          font: 'Nothing You Could Do, cursive',
        },
        {
          font: 'Sacramento, cursive',
        },
      ],
      isActive: true,
    },
    {
      key: 'Company_Stamp',
      label: companyStamp,
      placeholder: companyStamp,
      companyLogo: '',
      isActive: true,
    },
    {
      key: 'Label',
      label: 'Label',
      placeholder: 'Label',
      labelColours: [
        {
          colourName: 'Red',
          colourHexCode: '#f65158',
        },
        {
          colourName: 'Yellow',
          colourHexCode: '#fbb755',
        },
        {
          colourName: 'Green',
          colourHexCode: '#159e79',
        },
        {
          colourName: 'Light Grey',
          colourHexCode: '#cecece',
        },
        {
          colourName: 'Mid Grey',
          colourHexCode: '#848484',
        },
      ],
      isActive: true,
    },
    {
      key: 'Source',
      label: t(sourcePath),
      placeholder: t(sourcePath),
      relation: {
        loading: false,
        sampleType: [],
        location: null,
        locationType: null,
        locationPlacement: null,
        attribute: null,
        output: null,
        subLocation: null,
        pages: null,
        control: null,
        tableColumn: null,
        hasError: false,
      },
      isActive: true,
    },
    {
      key: 'Calculation',
      label: t(calculationPath),
      placeholder: t(calculationPath),
      colourArray: [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ],
      relation: {
        mainLoader: false,
        formulaArray: [],
        currLocation: {
          label: 'Product Core Information',
          name: 'Product_Core_Information',
          _id: 11,
        },
        currSubLocation: null,
        counter: 0,
        locationArray: productListLocationsArray,
        filteredLocationArray: productListLocationsArray,
        filteredSubLocationArray: [],
        subLocationArray: [],
        formulaString: '',
        readOnlyFormulaString: '',
        hasError: false,
        undo: [],
        redo: [],
      },
      isActive: true,
    },
  ];
};

const initialState = {
  editPopup: false,
  editpopupData: null,
  editpopupChildData: null,
  editPopupPageIndex: -1,
  editPopupGridIndex: -1,
  editPopupPageId: '',
  tableGridIndex: -1,
  tablePageIndex: -1,
  tableControls: null,
  leftColumn,
  disableDrag: false,
  modalEdit: false,
  controlPanelOpen: true,
};
const rowHeight = 1122.52 / 50; // A4 height divided by number of rows
export const StateContext = createContext(null);
export default function CustomModuleStateProvider({ children }) {
  initialState.tableControls = useTableControls();
  const [customModuleState, setCustomModuleState] = useState({ ...initialState });

  const toggleEditPopup = () => {
    setCustomModuleState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupPageIndex: -1,
      editPopupGridIndex: -1,
      editPopupPageId: '',
    }));
  };

  const memoizedContextValue = useMemo(
    () => ({
      customModuleState,
      setCustomModuleState,
      initialState,
      toggleEditPopup,
      rowHeight,
    }),
    [customModuleState, setCustomModuleState, initialState, toggleEditPopup, rowHeight],
  );

  return <StateContext.Provider value={memoizedContextValue}>{children}</StateContext.Provider>;
}

export function useCustomModuleState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the CustomModuleStateProvider');
  }
  return context;
}
